import { useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { loadTossPayments } from "@tosspayments/tosspayments-sdk";
import styled from "styled-components";
import Lottie from 'lottie-react-web';

import FetchModule from "../../../Model/Network/FetchModule";

// Animation //
import LoadingAnimation from '../../../Animation/LoadingAnimation.json';
// Animation //

export default function CardRegistrationRequestPage() {
  const navigate = useNavigate();
  const params = useParams();
  

  // const TosspaymentsKey = 'test_ck_Z1aOwX7K8mXqxz6Be1YPryQxzvNP';
  const TosspaymentsKey = 'live_ck_0RnYX2w532YqXGNWelWl8NeyqApQ';
  const url = 'https://coach.link-zone.org';
  // const url = 'http://192.168.0.101:7070';

  // 카드 등록을 위한 토클 발행 후 카드 등록 실행 //
  useEffect(() => {
    window.localStorage.setItem('Token', 'Bearer ' + params.token);
    
    let merchantUid = params.merchantUid;
    let itemName = params.itemName;

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataOfCoachVer2('card/auth_publication', 'GET');
        
        if (responseData.status === 200) {
          let token = responseData.data.token;
          let userId = responseData.data.userId;
          let customerKey = responseData.data.customerKey;

          const tosspayments = await loadTossPayments(TosspaymentsKey);

          const brandPay = tosspayments.brandpay({
            customerKey: customerKey,
            redirectUrl: url + '/api2/card/registration/auth'
          })

          brandPay.addPaymentMethod()
            .then(function () {
              let requestData = {
                itemName: itemName,
                merchantUid: merchantUid,
                userId: userId,
                customerKey: customerKey,
                token: token
              }
              
              const fetchModule = new FetchModule();
              (
                async () => {
                  const responseData = await fetchModule.postDataOfEventVer2('sales/registration/success', 'POST', requestData);

                  if (responseData.status === 200) {
                    let encodedeMessage = encodeURIComponent('결제가 완료되었습니다');

                    navigate('/payment/complete/200/' + encodedeMessage);
                  }
                  else {
                    let encodedeMessage = encodeURIComponent(responseData.error);

                    navigate('/payment/complete/400/' + encodedeMessage);
                  }
                }
              )();
            })
            .catch((e) => {
              console.log('brand pay error');
              console.log(e);

              let encodedeMessage = encodeURIComponent('카드 등록에 실패하였습니다');

              navigate('/payment/complete/400/' + encodedeMessage);
            })
        }
        else {
          let encodedeMessage = encodeURIComponent('카드등록 절차가 실패하였습니다');
          
          navigate('/payment/complete/400/' + encodedeMessage);
        }
      }
    )();
  }, [TosspaymentsKey]);

  return (
    <TopLevelWrapper id='payment-method'>
      <LottieWrapper>
        <LottieBox>
          <Lottie options={{ animationData: LoadingAnimation }} />
        </LottieBox>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000'>결제 모듈 로딩중...</Text>
      </LottieWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 100vh;

  background-color: #FFFFFF;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const LottieBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 60px;
  height: 60px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize};

  color: ${props => props.color};

  margin: 0 0 0 0;
`;